import { AppThunk } from '../store'
import { setErrors } from '../common/errorsSlice'
import {
  TimelineResponse,
  Scheduler,
  Actions,
} from '../../types/member'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GetTimeLineParams, getActionsResponse, getSchedulerResponse, getTimesResponse } from '../../types/timeline'
import { getActions, getScheduler, getTimes } from '../../apis/timeline'

interface MemberInfo {
  [key: number]: {
    times?: getTimesResponse
    actions?: Actions
    scheduler?: Scheduler
  }
}

interface TimeLinesState extends Pick<TimelineResponse, 'max_count'> {
  members: MemberInfo
}

interface ActionsResponseWithId {
  id: number
  value: getActionsResponse
}

interface TimeSchedulerWithId {
  id: number
  value: getTimesResponse
}

interface SchedulerResponseWithId {
  id: number
  value: getSchedulerResponse
}

const initialState: TimeLinesState = {
  max_count: 0,
  members: {},
}

const timelineSlice = createSlice({
  name: 'timeline',
  initialState,
  reducers: {
    buildTimesSuccess: (state, action: PayloadAction<TimeSchedulerWithId>) => {
      state.members[action.payload.id].times = action.payload.value
      return state
    },
    buildActionsSuccess: (state, action: PayloadAction<ActionsResponseWithId>) => {
      if (state.max_count < action.payload.value.max_count) {
        state.max_count = action.payload.value.max_count
      }
      state.members[action.payload.id].actions = action.payload.value.actions
      return state
    },
    buildSchedulerSuccess: (state, action: PayloadAction<SchedulerResponseWithId>) => {
      state.members[action.payload.id].scheduler = action.payload.value.scheduler
      return state
    },
    setMembers: (state, action: PayloadAction<number[]>) => {
      state.members = action.payload.reduce((result: MemberInfo, id) => ({
        ...result,
        [id]: { },
      }), {})
      return state
    },
    requestFailure: (state) => state,
  },
})

export const {
  setMembers,
  requestFailure,
  buildTimesSuccess,
  buildActionsSuccess,
  buildSchedulerSuccess,
} = timelineSlice.actions

export const memberTimelineReducer = timelineSlice.reducer

export const fetchActions = (
  param: GetTimeLineParams,
): AppThunk => async (dispatch) => {
  getActions(param)
    .then((result: getActionsResponse) => {
      dispatch(buildActionsSuccess({ id: param.member_id, value: result }))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchScheduler = (
  param: GetTimeLineParams,
): AppThunk => async (dispatch) => {
  getScheduler(param)
    .then((result: getSchedulerResponse) => {
      dispatch(buildSchedulerSuccess({ id: param.member_id, value: result }))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchTimes = (
  param: GetTimeLineParams,
): AppThunk => async (dispatch) => {
  getTimes(param)
    .then((result: getTimesResponse) => {
      dispatch(buildTimesSuccess({ id: param.member_id, value: result }))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}
